/* eslint-disable no-unused-vars */
import Vue from 'vue'
import App from './App.vue'
import Router from './router'

import "./assets/css/mobile.css"
import "./assets/css/reset.css"
import 'vue-photo-preview/dist/skin.css'
import 'element-ui/lib/theme-chalk/index.css'
import "./assets/font-awesome-4.7.0/css/font-awesome.min.css"

import 'lib-flexible'
import axios from 'axios'
import preview from 'vue-photo-preview'
import ElementUI from 'element-ui'
import share from './share'
import store from './vuex/store'
import VueLazyLoad from 'vue-lazyload'
import loading from './assets/images/loading.gif'
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import waterfall from 'vue-waterfall2'
import vant from 'vant'

Vue.use(preview)
Vue.use(ElementUI);
Vue.use(vant);
Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  error: loading,
  loading: loading,
  attempt: 1
})

Vue.use(vueSwiper)
Vue.use(waterfall)

axios.defaults.withCredentials = true
Vue.prototype.axios = axios;
Vue.prototype.$bus = new Vue();

Vue.prototype.$bus.$on('setTitle', (msg) => {
  // eslint-disable-next-line no-console
  console.log(msg)
  document.title = msg.title
  document.getElementsByName("description")[0].content = msg.description||msg.title
  document.getElementsByName("shareImage")[0].content = msg.shareImage
})

Vue.prototype.$openZGApp = (url, defaultUrl) => {
  const t = Date.now()
  window.location.href = url

  if (window.navigator.userAgent.indexOf('ZgApp') < 0) {
    setTimeout(() => {
      if (!document.hidden || !document.webkitHidden || Date.now() - t < 2200) {
        window.location.href = defaultUrl
      }
    }, 2000)
  }
}

Vue.config.productionTip = false

Router.afterEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  window.scrollTo(0, 0);
})

new Vue({
  render: h => h(App),
  store,
  router: Router
}).$mount('#app')

let timerId = setInterval(function() {
  //console.log("window.WXToken",window.WXToken);
  if(window.WXToken){
      share.init();
      clearInterval(timerId);
  }
}, 200);


